import { namespacedConsts } from '../../utils/object'
import { appDispatcher } from '../../application/AppDispatcher'

const CONSTS = namespacedConsts({
  EMBED_MODAL: {
    ACTIONS: {
      EMBED_DATA_RECEIVED: true,
      EMBED_DATA_FAILED: true,
      EMBED_CONFIGURATION_CHANGED: true,
    },
  },
})

export const TYPES = CONSTS.EMBED_MODAL.ACTIONS

export const embedDataReceived = data => {
  appDispatcher.dispatchAction.server({
    type: TYPES.EMBED_DATA_RECEIVED,
    data,
  })
}

export const embedDataFailed = () => {
  appDispatcher.dispatchAction.server({
    type: TYPES.EMBED_DATA_FAILED,
  })
}

export const embedConfigurationChanged = configOption => {
  appDispatcher.dispatchAction.view({
    type: TYPES.EMBED_CONFIGURATION_CHANGED,
    configOption,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/embedCodeModalActions.js